import React, { ReactElement } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { PublicAppFrame, AdminAppFrame } from './Frame';

const RouteBuilder = (
  Frame: React.ComponentType<{ children: React.ReactElement }>
) => (props: RouteProps): React.ReactElement => (
  <Frame>
    <Route {...props} />
  </Frame>
);

// Do not hold Xing shell for admin routes
export const RootAdminRoute = RouteBuilder(AdminAppFrame);
export const RootPublicRoute = RouteBuilder(
  PublicAppFrame() as React.ComponentType<{ children: React.ReactElement }>
);
